'use strict';

function getClientLabel(client) {
  return client ? client.lastName + ' ' + client.name : '';
}

// eslint-disable-next-line no-unused-vars
function ClientLabel() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {
      client: '<'
    },
    // eslint-disable-next-line no-unused-vars
    link: function(scope) {
      const { client } = scope;
      scope.clientLabel = getClientLabel(client);
    },
    template: '{{ clientLabel }}'
  };
}

export { ClientLabel as default, getClientLabel };
